<template>
  <div>
    <title-edit header="Design world calendar" />
    <line-hr />
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        &nbsp;
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <v-app class="switch-app">
        </v-app>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Name TH* :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-text-field :model="form.name_th" @update="updateNameTH"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Name EN* :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-text-field :model="form.name_en" @update="updateNameEN"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Description TH* :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-text-area :model="form.description_th" @update="updateDescriptionTH"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Description EN* :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-text-area :model="form.description_en" @update="updateDescriptionEN"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Publish date* :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <date-picker :model="form.event_date" @update="updatePublishDate"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Location* :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-text-field :model="form.location" @update="updateLocation"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Image :</label>
        <div style="color: #2E8037; font-size: 12px">
          *รองรับ JPEG ,PNG ขนาดไฟล์ไม่เกิน 700 x 700 px
        </div>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-image-upload id="image1" :model="form.image_show" @update="updateImage"/>
      </v-col>
    </div>
    <line-hr />
    <div class="row text-right">
      <v-spacer></v-spacer>
      <delete-button @click.native="deleteData"/>
      <preview-button />
      <save-button @click.native="saveData"/>
    </div>
  </div>
</template>

<script>
    import TitleEdit from "../../components/TitleHeader/TitleEdit";
    import LineHr from "../../components/Icon/line-hr";
    import InputTextField from "../../components/Input/InputTextField";
    import InputEditor from "../../components/Input/InputEditor";
    import DeleteButton from "../../components/Button/DeleteButton";
    import PreviewButton from "../../components/Button/PreviewButton";
    import SaveButton from "../../components/Button/SaveButton";
    import DatePicker from "../../components/Input/DatePicker";
    import InputTextArea from "../../components/Input/InputTextArea";
    import InputImageUpload from "../../components/Input/InputImageUpload";
    import {mapState} from "vuex";
    export default {
        name: "DesignWorldCalendarEdit",
      components: {
        InputImageUpload,
        InputTextArea,
        DatePicker,
        SaveButton,
        PreviewButton, DeleteButton, InputEditor,
        InputTextField, LineHr, TitleEdit},
      data(){
          return{

          }
      },
      computed: {
        ...mapState({
          form: state => {
            return state.DesignWorldCalendar.form;
          }
        })
      },
      methods:{
        saveData(){
          this.$store.dispatch("DesignWorldCalendar/saveDesignWorldCalendar",{
            id : this.form.id,
            data : this.form
          }).then(res=>{
            alert(res.response_msg);
            if(res.response_code == 200){
              this.goToDesignTable();
            }
          }).catch(()=>{
            alert('cannot save design world calendar')
          })
        },
        deleteData(){
          this.$store.dispatch("DesignWorldCalendar/deleteDesignWorldCalendar").then(res=>{
            alert(res.response_msg);
            if(res.response_code == 200){
              this.goToDesignTable();
            }
          }).catch(()=>{
            alert('cannot delete design world calendar')
          })
        },
        goToDesignTable(){
          this.$router.push("/design-world-calendar")
        },
        updateNameTH(val){
          this.form.name_th = val;
        },
        updateNameEN(val){
          this.form.name_en = val;
        },
        updateDescriptionTH(val){
          this.form.description_th = val;
        },
        updateDescriptionEN(val){
          this.form.description_en = val;
        },
        updatePublishDate(val){
          this.form.event_date = val;
        },
        updateLocation(val){
          this.form.location = val;
        },
        updateImage(val){
          this.form.image = val.imagePath;
          this.form.image_show = val.fullImagePath;
        }
      }
    }
</script>

<style scoped>

</style>
